// AUTO-GENERATED by scripts/generate-version.js — do not edit directly.
// Regenerated on every `npm start` / `npm run build` from package.json.
export const APP_VERSION = '2.4.0';
